import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-leadership-create',
  templateUrl: './leadership-create.component.html',
  styleUrls: ['./leadership-create.component.scss']
})
export class LeadershipCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  coursename = null;
  submitted = false;
  public leadershipForm: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/leadershipbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.leadershipForm.patchValue({
              _id: data.data._id,
              name: data.data.name,
              designation: data.data.designation,
              profile: data.data.profile,
              image: data.data.image,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });
    

    this.leadershipForm = this.formBuilder.group({
      name: ['', Validators.required],
      designation: ['', Validators.required],
      profile: ['', Validators.required],
      image: ['', Validators.required],
      _id: ['']
    })
  }

  get f() { return this.leadershipForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.leadershipForm.invalid) {
      return;
    }

    
      // console.log(this.coursename);
    if(this.action == 'Submit'){

      

    var data = {
      "name" : this.leadershipForm.value.name,
      "designation" : this.leadershipForm.value.designation,
      "profile" : this.leadershipForm.value.profile,
      "image" : this.leadershipForm.value.image,
      "admin" : sessionStorage.getItem('adminName'),
    };
    console.log(data);
    
    this.http.post<any>(this.api_endpoint+'/leadership', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/leadership/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
    }else{
      var data1 = {
        "name" : this.leadershipForm.value.name,
        "designation" : this.leadershipForm.value.designation,
        "profile" : this.leadershipForm.value.profile,
        "image" : this.leadershipForm.value.image,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.leadershipForm.value._id,
      };
        // console.log(data1);     
        this.http.put<any>(this.api_endpoint+'/leadership/', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/leadership/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
